import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Localidad',
            tblTitle: 'Lista de localidades',
            tblbutton: 'Nueva localidad',
            mdlSave: 'Guardar',
            mdlCancel: 'Cancelar',
            mdltext1: 'Localidad',
            mdltext2: 'Descripción',
            mdltext3: 'Nueva localidad',
            mdltext4: 'Editar localidad',

            headerUbicacion: 'Localidad',
            headerDescripcion: 'Descripción',
            headerEstado: 'Estado',
            headerAcciones: 'Acciones',

            lblEdit: 'Editar',
            lblMeeting: 'Salas de juntas',
            lblSetting: 'Configuraciones de la localidad',
            lblSearch: 'Buscar',
        },
        en: {
            moduleTitle: 'Locations',
            tblTitle: 'Location list',
            tblbutton: 'New location',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',
            mdltext1: 'Location',
            mdltext2: 'Description',
            mdltext3: 'New location',
            mdltext4: 'Edit location',

            headerUbicacion: 'Location',
            headerDescripcion: 'Description',
            headerEstado: 'State',
            headerAcciones: 'Actions',
            lblEdit: 'Edit',
            lblMeeting: 'Meeting rooms',
            lblSetting: 'Location settings',
            lblSearch: 'Search',
        }
    }
}

export default _.merge(messages, defaultMessages)